
    import Vue from 'vue';

    
    let _i18n_vue = new Vue();
    const $t = _i18n_vue.$t.bind(_i18n_vue);
    
export default {
  namespaced: true,
  state: {
    queryCondition: {
      deptUid: null,
      selectChannelIds: [],
      indexComparision: {
        labelId: '',
        labelName: '',
      },
      labelFilter: null,
    },
    selectLabel: $t('28608f'),
    selectLabelId: '',
    nextNodenames: [],
    treeData: null,
  },
  getters: {
    commonRequestParams: state => {
      return {
        deptUid: state.queryCondition.deptUid,
        channels: state.queryCondition.selectChannelIds,
        labelFilter: state.queryCondition.labelFilter,
      }
    },
  },
  mutations: {
    SET_QUERY_CONDITION(state, condition = {}) {
      Object.assign(state.queryCondition, condition)
    },
    SET_SELECTLABEL(state, label) {
      state.selectLabel = label || $t('28608f')
    },
    SET_NEXTNODENAMES(state, nextNodeNames) {
      state.nextNodenames = nextNodeNames
    },
    SET_SELECTLABELID(state, selectLabelId) {
      state.selectLabelId = selectLabelId
    },
    SET_TREEDATA(state, treeData) {
      state.treeData = treeData
    },
  },
}
